import SmoothScrollbars from "@rio-cloud/rio-uikit/components/smoothScrollbars/SmoothScrollbars";
import { ExtractData } from "./types/types";
import { EmptyState } from "@rio-cloud/rio-uikit";
import NotFoundState from '@rio-cloud/rio-uikit/NotFoundState';
import './IdentifiedFailures.css'

type IdentifiedFailuresProps = {
  failures: ExtractData["failures"];
};

export function IdentifiedFailures({ failures }: IdentifiedFailuresProps) {
  if (failures.length === 0) {
    return (
      <NotFoundState
        outerClassName="height-300"
        headline='Nenhuma entrada encontrada' 
        message='Não foi possível encontrar nenhuma entrada de dados para esta viagem.'
      />
    );
  } else 
  return (
    <div className="panel panel-default padding-0 panel-body margin-bottom-0 aspect-ratio-16-9">
      <SmoothScrollbars className="height-300">
        <div className={"display-grid padding-y-10 padding-x-5 cq-500:padding-20 gap-20"}>
          {failures.map((failure) => (
            <div
              key={failure.sourceAddressCode}
              className="display-grid gap-10"
            >
              <span className="text-size-16 cq-500:text-size-20 text-medium">
                {failure.sourceAddressDescription}
              </span>
              <div className="list-group border rounded">
                {failure.spnErrors.length === 0 ? <EmptyState /> : failure.spnErrors.map((error) => (
                  <div key={error.errorCode} className="list-group-item">
                    <span>
                      <code className="code-inline text-color-dark">
                        {error.errorCode}
                      </code>{" "}
                      {error.errorDescription}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div className="height-20" />
        </div>
      </SmoothScrollbars>
    </div>
  );
}
